/**
 * v3.21-1707 — Smart Dialer standalone page for regular internal team members.
 * Renders ONLY the operational Smart Dialer.  Reuses the exact same
 * <SmartDialer /> component used inside TelephonyPage — one functional
 * implementation, two authorized surfaces.
 */
import React from 'react';
import SmartDialer from '../components/SmartDialer';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';

export default function SmartDialerPage() {
  return (
    <div className="p-4 sm:p-6 max-w-full min-w-0" data-testid="smart-dialer-page">
      <div className="mb-3">
        <h1 className="text-lg font-semibold text-slate-800">Smart Dialer</h1>
        <p className="text-xs text-slate-500">Outbound queue &amp; call controls.</p>
      </div>
      <SectionErrorBoundary label="Smart Dialer">
        <SmartDialer />
      </SectionErrorBoundary>
    </div>
  );
}
